import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { getAdministrativeDocumentYearsOptions } from 'src/utils/utils';
import { clearListAllAdministrativeServicesData } from "src/redux/administrativeService/administrativeServiceActions";
import { getListAllServiceAdministrativeByUserData } from "src/redux/administrativeService/administrativeServiceReducer";
import { getSelectedFundRequestType } from 'src/redux/fundRequests/fundRequestsReducer';
import { getBankAccountListData } from 'src/redux/bankAccounts/bankAccountReducer';
import {
	getProvisionOrderListIsFetching,
	getOrderPayListData
} from 'src/redux/orderPay/orderPayReducer';
import { tryListOrderPay } from 'src/redux/orderPay/orderPayActionCreator';
import { clearListOrderPayData } from 'src/redux/orderPay/orderPayActions'
import PFCommons from 'src/components/forms/fundRequest/PDForms/controls/PFCommons';
import AppLoading from 'src/components/common/AppLoading';
import PayOrderListBox from "src/components/forms/fundRequest/payOrderListBox";
import { tryOrderPayById } from 'src/redux/orderPay/orderPayActionCreator';

const FundRequestSubsidiesForm = () => {
	const dispatch = useDispatch();

	//Parent Form Controller
	const { admServiceId, setAdmServiceId } = useFormContext();

	//Data getter to send by props
	let dataRecords = useSelector(state => getOrderPayListData(state))?.records;
	const metaData = useSelector(state => getOrderPayListData(state))?.metadata;
	const [ordenes, setOrdenes] = useState(dataRecords);

	const selectedFundRequestType = useSelector(state => getSelectedFundRequestType(state));
	const checkToVisualize = false;
	const bankAccountListData = useSelector(state => getBankAccountListData(state))?.records || [];
	const yearsOptions = getAdministrativeDocumentYearsOptions();
	const [bankAccountListDataFiltered, setBankAccountListDataFiltered] = useState([]);
	const isFetching = useSelector(state => getProvisionOrderListIsFetching(state));

	const administrativeServiceData = useSelector(state => getListAllServiceAdministrativeByUserData(state))
		?.sort((a, b) => a.code > b.code ? 1 : -1)
		?.map(item => ({
			displayName: `${item?.code} - ${item?.name}`,
			id: item?.id,
			name: item?.name
		}));

	useEffect(() => {
		dispatch(clearListAllAdministrativeServicesData());
	}, [admServiceId]);

	const applyFilterBankAccounts = (administrativeServiceId) => {
		setAdmServiceId(administrativeServiceId);
		setBankAccountListDataFiltered(bankAccountListData?.filter(item => item.administrativeServiceId == administrativeServiceId));
	};

	useEffect(() => {
		if (!dataRecords?.length) {
			setOrdenes([]);
			return;
		}
		const allPromises = [];
		dataRecords.forEach(op => {
			allPromises.push(dispatch(tryOrderPayById(op.id)));
		});
		Promise.all(allPromises).then((values) => {
			setOrdenes(values);
		});
	}, [dataRecords]);

	return <>
		<PFCommons
			yearsOptions={yearsOptions}
			administrativeServiceData={administrativeServiceData}
			applyFilterBankAccounts={applyFilterBankAccounts}
			bankAccountListDataFiltered={bankAccountListDataFiltered}
			admServiceId={admServiceId}
			checkToVisualize={checkToVisualize}
		/>

		<PayOrderListBox
			selectedFundRequestType={selectedFundRequestType}
			isFetching={isFetching}
			tryMethod={tryListOrderPay}
			clearMethod={clearListOrderPayData}
			metaData={metaData}
			ordenes={ordenes}
			dataRecords={dataRecords}
		/>

		<AppLoading isLoading={isFetching} />
	</>

};

export default FundRequestSubsidiesForm;